import angular from 'angular'

angular.module('nominas.cotizacion')
  .config(($stateProvider) => {
    $stateProvider.state('nominas.cotizacion.informacion', {
      data: {title: 'Prenómina {{::nominasCotizacion.Folio}}'},
      url: '',
      template: '<nominas-cotizacion-informacion data="data"></nominas-cotizacion-informacion>',
      controller: ($state, data) => {
        $scope.data = data
      },
    });
  });



// WEBPACK FOOTER //
// ./src/nominas/cotizacion/routes/cotizacion/informacion.js